import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';

import CorpNewsYears from './corpNewsYears';
import CorpNewsList from './corpNewsList';
import ConNav from './conNav';
import Banner from './banner';
class Content extends React.Component {
    constructor() {
        super();
        this.conNavHeader = {
            navCenter: '公司简介',
            navRight: '凤凰新媒体',
        };

        this.state = {
            yearsContent: 'newList2026',
        };
    }

    static propTypes = {
        content: PropTypes.object,
    };

    handleMouseYears = content => {
        this.setState({
            yearsContent: content,
        });
    };

    render() {
        const { content } = this.props;

        return (
            <div className={styles.pageBody}>
                <div className={styles.page}>
                    <div className={styles.pageHead}>
                        <div className={styles.pageEnd}>
                            <div className={styles.myContent}>
                                <Chip
                                    id="162635"
                                    type="static"
                                    title="首图banner"
                                    groupName="首图banner"
                                    content={content}>
                                    <Banner />
                                </Chip>
                                <ConNav conNavHeader={this.conNavHeader} />
                                <div className={styles.contIntro} id="record">
                                    <div className={styles.title}>
                                        <img src="http://img.ifeng.com/info/ifeng_record.gif" />
                                    </div>
                                    <CorpNewsYears onMouseMove={index => this.handleMouseYears(index)} />
                                </div>
                                <div className={styles.conChannel}>
                                    <CorpNewsList yearsConData={this.state.yearsContent} content={content} />
                                </div>
                            </div>
                            <div className={styles.clear} />
                        </div>
                    </div>
                </div>
                <div className={styles.border} />
            </div>
        );
    }
}

export default Content;
